<template>
  <div class="conteudo">
    <b-container fluid class="custom-container-fluid">
      <b-row>
        <b-col class="col-12 col-lg-7 col-xl-6 align-self-center mb-5">
          <b-row>
            <b-col class="offset-6 col-6 col-md-3 offset-md-9 d-lg-none text-right pr-0 d-none d-md-block">
              <b-img fluid src="/img/login_mobile.png"></b-img>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-lg-7 col-xl-7">
              <div class="pt-5 pb-3">
                <h6 class="text-white mb-0">CHEGAMOS PARA</h6>
                <h4 class="text-white">
                  AJUDAR A REALIZAR<br />OS SEUS PLANOS.
                </h4>
              </div>
              <div class="">
                <p class="text-white mb-2 pl-3">
                  <small>CPF:</small>
                </p>
                <b-form-input placeholder="Digite o seu CPF"></b-form-input>
              </div>
              <b-row>
                <b-col class="col-12 col-md-6 pt-3">
                  <b-button variant="light" class="btn-verde-2 w-100"
                    >ENTRAR</b-button
                  >
                </b-col>
                <b-col class="col-12 col-md-6 pt-3">
                  <b-button variant="dark" class="btn-verde-3 w-100"
                    >CRIAR CONTA</b-button
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-8 pt-3">
              <p class="text-white">
                Para ter acesso às vantagens da FINLEV, a empresa que você
                trabalha precisa ser conveniada. Fale com o seu gestor ou
                cadastre a sua empresa para receber a visita de nossos gestores;
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="col-12 d-none d-lg-block col-lg text-right">
          <b-img fluid src="/img/login.png"></b-img>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Login"
};
</script>

<style>
.bg_flat {
  background-image: none !important;
  background-color: #396477 !important;
}

@media (max-width: 991px) {
    .col-mt-neg{
        margin-top: -20%;
    }
}

@media (min-width: 992px) {
  .custom-container-fluid {
    padding-right: 0px !important;
  }
}

.custom-input-2 {
  width: auto !important;
}
</style>